export interface NavItem {
  id: string;
  label: string;
  icon: string;
  path: string;
  /** Ruta al entrar desde el menu principal; por defecto la del primer subitem. */
  landingPath?: string;
  active?: boolean;
  subItems?: SubItem[];
}

export interface SubItem {
  id: string;
  label: string;
  icon: string;
  path: string;
  active?: boolean;
  itemsActions?: ItemActions[];
}

export interface ItemActions {
  id: string;
  label: string;
  icon: string;
  path?: string;
  active?: boolean;
}

export interface ItemActionOrNavigation {
  id: string;
  label: string;
  icon: string;
  type: 'action' | 'navigation';
  path?: string;
  active?: boolean;
}

export interface GroupItemActions {
  code: string;
  itemsActions: ItemActionOrNavigation[];
}



export const navItems: NavItem[] = [
    { 
        id: 'dashboard', 
        label: 'Dashboard', 
        icon: 'grid', 
        path: '/dashboard'
    },
    { 
        id: 'ventas', 
        label: 'Ventas', 
        icon: 'trending-up', 
        path: '/ventas',
        subItems: [
            { id: 'por-salon', label: 'Por salon', icon: 'ventas-grid', path: '/ventas/por-salon'},
            { id: 'venta-rapida', label: 'Venta rápida', icon: 'zap', path: '/ventas/venta-rapida',
                itemsActions: [
                    { id: 'editar-mesa', label: 'Editar mesa', icon: 'edit'},
                    { id: 'dividir-cuentas', label: 'Dividir Cuentas', icon: 'scissors'},
                    { id: 'unir-mesa', label: 'Unir mesa', icon: 'link'},
                    { id: 'mover-pedido', label: 'Mover Pedido', icon: 'move'},
                ]

             },
            { id: 'venta-manual', label: 'Venta manual', icon: 'edit', path: '/ventas/venta-manual',
                itemsActions: [
                    { id: 'transferencia', label: 'Transferencia', icon: 'transfer' },
                    { id: 'agregar-descuentos', label: 'Agregar descuentos', icon: 'discount' }
                ]
             },
            { id: 'pedidos-multimozo', label: 'Pedidos Multimozo', icon: 'ventas-users', path: '/ventas/pedidos-multimozo' },
        ]
    },
    { 
        id: 'caja', 
        label: 'Caja', 
        icon: 'monitor', 
        path: '/caja',
        subItems: [
            { id: 'apertura-cierre', label: 'Apertura y Cierre', icon: 'caja-apertura', path: '/caja/apertura-cierre' },
            { id: 'historial-ventas', label: 'Historial de ventas', icon: 'caja-historial', path: '/caja/historial-ventas' },
            { id: 'ingresos-egresos', label: 'Ingresos y egresos', icon: 'caja-ingresos', path: '/caja/ingresos-egresos' },
            { id: 'cierres-caja', label: 'Cierres de Caja', icon: 'caja-cierres', path: '/caja/cierres-caja' },
            { id: 'monitor-ventas', label: 'Monitor de ventas', icon: 'caja-monitor', path: '/caja/monitor-ventas' },
        ]
    },
    {
        id: 'cocina',
        label: 'Cocina',
        icon: 'book-open',
        path: '/cocina',
        subItems: [
            { id: 'por-mesa', label: 'Por mesa', icon: 'ventas-grid', path: '/cocina/por-mesa' },
            { id: 'por-estados', label: 'Por estados', icon: 'clipboard', path: '/cocina/por-estados' },
            { id: 'por-cliente', label: 'Por cliente', icon: 'ventas-users', path: '/cocina/por-cliente' },
            { id: 'por-pedidos', label: 'Por pedidos', icon: 'file-text', path: '/cocina/por-pedidos' },
        ]
    },
    { 
        id: 'productos', 
        label: 'Productos', 
        icon: 'package', 
        path: '/productos',
        subItems: [
            { id: 'categorias-productos', label: 'Categorias y Productos', icon: 'categoria-productos', path: '/productos/categorias' },
            { id: 'combos', label: 'Combos', icon: 'combos', path: '/productos/combos' },
            { id: 'menu', label: 'Menu', icon: 'menu', path: '/productos/menus' },
            { id: 'modificadores', label: 'Modificadores', icon: 'modificadores', path: '/productos/modificadores' },
            { id: 'insumos', label: 'Insumos', icon: 'insumos', path: '/productos/insumos' },
            { id: 'descartables', label: 'Descartables', icon: 'descartables', path: '/productos/descartables' },
            { id: 'consumibles', label: 'Consumibles', icon: 'consumibles', path: '/productos/consumibles' }
        ]
    },
    { 
        id: 'compras', 
        label: 'Compras', 
        icon: 'shopping-cart', 
        path: '/compras' 
    },
    { 
        id: 'almacenes', 
        label: 'Almacenes e inventario', 
        icon: 'archive', 
        path: '/almacenes' 
    },
    { 
        id: 'recetas', 
        label: 'Recetas', 
        icon: 'book-open', 
        path: '/recetas' 
    },
    {
        id: 'promociones',
        label: 'Promociones y descuentos',
        shortLabel: 'Dsctos.',
        icon: 'tag',
        path: '/promociones',
        subItems: [
            { id: 'descuentos', label: 'Descuentos', icon: 'promo-descuentos', path: '/promociones/descuentos' },
            { id: 'cupones', label: 'Cupones de descuento', icon: 'promo-cupones', path: '/promociones/cupones' },
            { id: 'dos-en-uno', label: '2 en 1', icon: 'promo-combo', path: '/promociones/dos-en-uno' },
            { id: 'dos-por-uno', label: '2 × 1', icon: 'promo-combo', path: '/promociones/dos-por-uno' },
            { id: 'precios-bajo', label: 'Precios bajo', icon: 'promo-combo', path: '/promociones/precios-bajo' },
        ]
    },
    { 
        id: 'informes', 
        label: 'Informes', 
        icon: 'file-text', 
        path: '/informes' 
    },
    { 
        id: 'clientes',
        label: 'Clientes',
        icon: 'users',
        path: '/clientes',
        landingPath: '/clientes',
        subItems: [
            { id: 'agregar-cliente', label: 'Agregar', icon: 'clientes-agregar', path: '/clientes/agregar' },
        ]
    },
    { 
        id: 'credito', 
        label: 'Crédito', 
        icon: 'credit-card', 
        path: '/credito' 
    },
    { 
        id: 'finanzas', 
        label: 'Finanzas', 
        icon: 'dollar-sign', 
        path: '/finanzas' 
    },
    { 
        id: 'comandas', 
        label: 'Comandas y precuentas', 
        icon: 'clipboard', 
        path: '/comandas' 
    },
    { 
        id: 'sucursales', 
        label: 'Sucursales', 
        icon: 'map-pin', 
        path: '/sucursales' 
    },
    { 
        id: 'impresion', 
        label: 'Gestión de impresión', 
        icon: 'printer', 
        path: '/impresion' 
    },
    { 
        id: 'indicadores', 
        label: 'Indicadores gráficos', 
        icon: 'bar-chart-2', 
        path: '/indicadores' 
    },
    {
        id: 'ajustes',
        label: 'Ajustes',
        shortLabel: 'Config. general',
        icon: 'settings',
        path: '/ajustes',
        subItems: [
            {
                id: 'salones-mesas',
                label: 'Salones y mesas',
                icon: 'ventas-grid',
                path: '/ajustes/salones-mesas'
            }
        ]
    },
  ];

export interface NavItem {
  id: string;
  label: string;
  /** Etiqueta corta para el titulo del sidebar cuando el modulo esta activo. */
  shortLabel?: string;
  icon: string;
  path: string;
  active?: boolean;
  subItems?: SubItem[];
}

export interface SubItem {
  id: string;
  label: string;
  icon: string;
  path: string;
  active?: boolean;
}
